
document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(min-width: 990px)').matches === false) return;

  document.querySelectorAll('header-menu > details').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;

    let closeTimer;

    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });

    details.addEventListener('toggle', () => {
      summary.setAttribute(
        'aria-expanded',
        details.open ? 'true' : 'false'
      );
    });
  });
});


